import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
const _hoisted_1 = { class: "data-table__top" };
const _hoisted_2 = { class: "data-table__filters" };
const _hoisted_3 = {
    key: 0,
    class: "data-table__title-slot"
};
const _hoisted_4 = { class: "data-table__title" };
const _hoisted_5 = ["title"];
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "data-table__actions" };
const _hoisted_8 = { class: "data-table__main" };
const _hoisted_9 = { class: "data-table__header" };
const _hoisted_10 = { class: "data-table__column data-table__column--list" };
const _hoisted_11 = {
    key: 0,
    class: "data-table__check"
};
const _hoisted_12 = ["checked"];
const _hoisted_13 = { class: "data-table__header-value" };
const _hoisted_14 = ["title"];
const _hoisted_15 = { class: "data-table__column-label" };
const _hoisted_16 = ["onMouseover"];
const _hoisted_17 = {
    key: 0,
    class: "data-table__cell"
};
const _hoisted_18 = {
    key: 0,
    class: "data-table__check"
};
const _hoisted_19 = ["checked", "onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "data-table__value" };
const _hoisted_22 = { class: "data-table__value-text" };
const _hoisted_23 = { class: "data-table__value-text" };
const _hoisted_24 = { class: "data-table__more" };
const _hoisted_25 = {
    key: 0,
    class: "data-table__too-many-results"
};
const _hoisted_26 = { class: "data-table__value" };
const _hoisted_27 = ["onClick", "title"];
import { onMounted, onUnmounted, ref, computed } from 'vue';
import { useRoute } from "vue-router";
import { throttle as _throttle } from 'lodash';
import events from "../services/EventBus";
import log from '../services/Logger';
import userSettings, {} from "../services/UserSettings";
import SearchFilters from "./SearchFilters.vue";
import Spinner from "./Spinner.vue";
import Help from "./Help.vue";
import ColumnSort from "./ColumnSort.vue";
import DataTableColumnsSelection from "./DataTableColumnsSelection.vue";
import DataTableColumnStatistics from "./DataTableColumnStatistics.vue";
import DataTableStatistics from "./DataTableStatistics.vue";
import DataTableBulkOperations from "./DataTableBulkOperations.vue";
import DataTableCell from "./DataTableCell.vue";
import palomaWebsocket, {} from "../services/WebSocket";
import { numberFilter } from "../util/CommonUiFilters";
import BadgeComponent from "./BadgeComponent.vue";
import Icon from "./Icon.vue";
import trans from "../services/Translator";
import favouriteItemsService from "../services/FavouriteItemsService";
const rowHeightDefault = 71;
const rowHeightCondensed = 46;
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTable',
    props: {
        grid: {},
        source: {},
        name: {},
        title: {},
        description: {},
        helpCode: {},
        translationPrefix: {},
        searchRequest: {},
        enforceSearchRequest: { type: Boolean },
        searchQueryPlaceholder: {},
        statistics: {},
        maxItems: {},
        activeItemIdRouteParam: { type: [String, Function] },
        itemRoute: {},
        itemRouteIdParam: {},
        variant: {},
        bulkOperations: {},
        userSettingsSuffix: {},
        noScrollIntoView: { type: Boolean },
        wsSettings: {},
        mode: {},
        showNulls: { type: Boolean },
        showBadges: { type: Boolean }
    },
    emits: [
        'search-request-changed',
        'columns-changed',
        'bulk-selection-changed',
        'page-loaded',
        'load-error',
        'activate-item',
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        class Range {
            from;
            to;
            size;
            constructor(from, to) {
                if (from > to) {
                    throw 'invalid range';
                }
                this.from = from;
                this.to = to;
                this.size = to - from;
            }
            contains(other) {
                return this.from <= other.from && this.to >= other.to;
            }
            intersectsOrTouches(other) {
                return (this.to >= other.from && this.to <= other.to && this.from <= other.from)
                    || (this.from >= other.from && this.from <= other.to && this.to >= other.to);
            }
            combine(other) {
                this.from = Math.min(this.from, other.from);
                this.to = Math.max(this.to, other.to);
                this.size = this.to - this.from;
            }
            next() {
                return new Range(this.to, this.to + this.size);
            }
            prev() {
                return new Range(this.from - this.size, this.from);
            }
        }
        class DataItemSlice {
            range;
            items;
            constructor(range, items) {
                this.range = range;
                this.items = items;
            }
            /**
             * Combines this slice with another.
             * Note: it is assumed that the items in `other` are sorted the
             * same way as this items.
             */
            combine(other) {
                if (!this.range.intersectsOrTouches(other.range)) {
                    throw 'can only combine slices that intersect or touch';
                }
                // replace items
                const replacedItemIds = [];
                for (let i = 0; i < this.items.length; i++) {
                    const item = other.items.find((item) => item.id === this.items[i].id);
                    if (item) {
                        this.items[i] = item;
                        log(`replaced item ${item.id} in current slice`);
                        replacedItemIds.push(item.id);
                    }
                }
                // prepend items
                if (this.range.from > other.range.from) {
                    for (let i = this.range.from - other.range.from; i > 0; i--) {
                        const item = other.items[i - 1];
                        if (replacedItemIds.indexOf(item.id) === -1) {
                            this.items.unshift(item);
                        }
                    }
                    // remove from the end
                    const toRemove = [other.range.to + other.range.size, this.range.to];
                    if (toRemove[0] < toRemove[1]) {
                        log('removing items from the end: ' + toRemove);
                        for (let i = toRemove[1]; i > toRemove[0]; i--) {
                            this.items.pop();
                            this.range.to -= 1;
                        }
                    }
                }
                // append items
                const effectiveRangeTo = Math.min(this.range.from + this.items.length, this.range.to);
                if (effectiveRangeTo < other.range.to) {
                    for (let i = effectiveRangeTo - other.range.from; i < other.items.length; i++) {
                        const item = other.items[i];
                        if (replacedItemIds.indexOf(item.id) === -1) {
                            this.items.push(item);
                        }
                    }
                    // remove from the beginning
                    const toRemove = [this.range.from, other.range.to - (other.range.size * 3)];
                    if (toRemove[0] < toRemove[1]) {
                        log('removing items from the beginning: ' + toRemove);
                        for (let i = toRemove[0]; i < toRemove[1]; i++) {
                            this.items.shift();
                            this.range.from += 1;
                        }
                    }
                }
                this.range.combine(other.range);
                log('new range: ' + [this.range.from, this.range.to]);
            }
        }
        class ItemSelections {
            allSelected = false;
            selection = {};
            clear() {
                this.allSelected = false;
                this.selection = {};
            }
            toggle(item) {
                const currentState = this.getState(item);
                switch (currentState) {
                    case 'included':
                        return this.exclude(item);
                    case 'excluded':
                        return this.include(item);
                    case 'unknown':
                        return this.allSelected
                            ? this.exclude(item)
                            : this.include(item);
                }
            }
            toggleAll() {
                this.allSelected = !this.allSelected;
                this.selection = {};
            }
            isSelected(item) {
                const state = this.getState(item);
                if (this.allSelected) {
                    return state !== 'excluded';
                }
                return state === 'included';
            }
            isAllSelected() {
                return this.allSelected;
            }
            count(total) {
                let included = 0;
                let excluded = 0;
                for (let id in this.selection) {
                    if (this.selection[id] === 'included') {
                        included++;
                    }
                    if (this.selection[id] === 'excluded') {
                        excluded++;
                    }
                }
                if (this.allSelected) {
                    return total - excluded;
                }
                return included;
            }
            selected() {
                const ids = [];
                for (let id in this.selection) {
                    if (this.selection[id] === 'included') {
                        ids.push(id);
                    }
                }
                return ids;
            }
            excluded() {
                const ids = [];
                for (let id in this.selection) {
                    if (this.selection[id] === 'excluded') {
                        ids.push(id);
                    }
                }
                return ids;
            }
            include(item) {
                this.selection[item.id] = 'included';
                return 'included';
            }
            exclude(item) {
                this.selection[item.id] = 'excluded';
                return 'excluded';
            }
            getState(item) {
                if (Object.prototype.hasOwnProperty.call(this.selection, item.id)) {
                    return this.selection[item.id];
                }
                return 'unknown';
            }
        }
        const emit = __emit;
        const props = __props;
        // --
        const searchRequest_ = ref({ query: null, filters: [] });
        const itemRefs = ref({});
        const columnsValue = ref({ columns: [] });
        const capabilities = ref({ search: true, bulkOperations: false, favourites: false });
        const filters = computed(createFilters);
        const slice = ref(new DataItemSlice(new Range(0, 0), []));
        const totalElements = ref(0);
        const moreElements = ref(false);
        const pageSize = ref(20);
        const maxItems_ = computed(() => props.maxItems || 10000);
        const tooManyResults = ref(false);
        const activateOnLoad = ref(null); // if set, this item will be activated if received on next load
        const itemActive = ref(null);
        const itemHighlighted = ref(null);
        const itemSelections = new ItemSelections();
        const selectedItemsCount = ref(0);
        const loading = ref(false);
        const dataTableClass = ref({});
        const headerWidth = ref(0);
        const dataWidth = ref(0);
        const dataHeight = ref(0);
        const dataPaddingTop = ref(0);
        const rowsMarginLeft = ref(0);
        const listMarginLeft = ref(0);
        const rowActionsMarginTop = ref(0);
        const rowHeight = ref(rowHeightDefault);
        const listWidth = ref(300);
        const showTableColumns = ref(true); // on mobile, we show only the list, not all table columns
        const userSettingsValue = ref(null);
        const wsSubscription = ref(null);
        const rootElement = ref(null);
        determineViewMode();
        initEventListeners();
        const refreshItemsForRange = _throttle(refreshItemsForRangeUnthrottled, 200);
        capabilities.value = props.grid.capabilities || capabilities.value;
        if (capabilities.value.bulkOperations && (props.bulkOperations ?? []).length === 0) {
            capabilities.value.bulkOperations = false;
        }
        if (capabilities.value.favourites && !favouriteItemsService.isAvailable()) {
            capabilities.value.favourites = false;
        }
        capabilities.value.statistics = !!(capabilities.value.statistics
            && props.grid.statistics
            && props.grid.statistics.items.length > 0
            && props.statistics);
        userSettingsValue.value = userSettings('paloma-ui.data-table.'
            + (props.grid.entity && props.grid.name != props.grid.entity.name ? (props.grid.name + '.') : '')
            + (props.userSettingsSuffix || props.name || Math.random() * 1000));
        const columns = {
            columns: props.grid.columns.map(col => {
                return { ...col, ...{ selected: col.visible, sorted: false } };
            })
        };
        const _userSettings = userSettingsValue.value.get({
            searchRequest: props.searchRequest,
            columns: [],
        });
        _userSettings.columns.forEach(column => {
            const col = columns.columns.find(col => col.name === column.name);
            if (col) {
                col.selected = column.selected;
                col.sorted = column.sorted;
                col.sortDirection = column.sortDirection;
            }
        });
        applyColumnsOrderUserSettings(_userSettings.columns, columns);
        applyColumnsSizeUserSettings(_userSettings.columns, columns);
        searchRequest_.value = initSearchRequest();
        columnsValue.value = columns;
        if (props.variant === 'condensed') {
            rowHeight.value = rowHeightCondensed;
        }
        activateItemByRoute();
        dataTableClass.value = {};
        dataTableClass.value['data-table--' + props.name] = true;
        dataTableClass.value['data-table--no-columns'] = !showTableColumns.value;
        dataTableClass.value['data-table--variant-' + (props.variant ?? 'default')] = true;
        dataTableClass.value['data-table--with-status-badge'] = hasStatusBadgeColumn();
        onMounted(() => {
            refreshLimit();
            refreshDataWidth();
            // loads the items!
            onColumnsChanged();
        });
        function initSearchRequest() {
            if (props.enforceSearchRequest && props.searchRequest) {
                return props.searchRequest;
            }
            // if we change the search filter here, we need to propagate the change
            //   to our parent (emit)!
            if (_userSettings.searchRequest
                && (_userSettings.searchRequest.query
                    || (_userSettings.searchRequest.filters && _userSettings.searchRequest.filters.length > 0))) {
                if (props.searchRequest !== _userSettings.searchRequest) {
                    emit('search-request-changed', _userSettings.searchRequest);
                }
                return _userSettings.searchRequest;
            }
            else {
                const newSearchFilter = (props.grid.defaults && props.grid.defaults.searchRequest)
                    || { query: null, filters: [] };
                emit('search-request-changed', newSearchFilter);
                return newSearchFilter;
            }
        }
        onUnmounted(() => removeEventListeners());
        function activateIfNoneActiveHandler(itemId) {
            if (!itemActive.value) {
                activateItemById(itemId);
            }
        }
        function initEventListeners() {
            window.addEventListener('resize', determineViewMode);
            if (!props.name) {
                return;
            }
            events.$on(props.name + '.refresh', resetSlice);
            events.$on(props.name + '.reload', () => loadItems(slice.value.range.from));
            events.$on(props.name + '.nav-next', activateNextItem);
            events.$on(props.name + '.nav-prev', activatePrevItem);
            events.$on(props.name + '.activate', activateItemById);
            events.$on(props.name + '.activate-if-none-active', activateIfNoneActiveHandler);
            if (props.wsSettings) {
                wsSubscription.value = palomaWebsocket.subscribe(props.wsSettings.destination, _throttle(() => events.$emit(props.name + '.' + props.wsSettings.onUpdate), 1000));
            }
        }
        function removeEventListeners() {
            window.removeEventListener('resize', determineViewMode);
            if (!props.name) {
                return;
            }
            events.$off(props.name + '.refresh');
            events.$off(props.name + '.reload');
            events.$off(props.name + '.nav-next');
            events.$off(props.name + '.nav-prev');
            events.$off(props.name + '.activate');
            wsSubscription.value && wsSubscription.value.unsubscribe();
        }
        function activateItem(item) {
            itemActive.value = item;
            emit('activate-item', itemActive.value);
            if (!props.noScrollIntoView && item) {
                const $ref = itemRefs.value[item.id];
                $ref && $ref.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
        }
        function activateNextItem() {
            const index = itemActive.value ? slice.value.items.indexOf(itemActive.value) : -1;
            if (slice.value.items.length > (index + 1)) {
                activateItem(slice.value.items[index + 1]);
            }
        }
        function activatePrevItem() {
            const index = itemActive.value ? slice.value.items.indexOf(itemActive.value) : -1;
            if (index > 0) {
                activateItem(slice.value.items[index - 1]);
            }
        }
        function isItemActive(item) {
            return item != null && itemActive.value != null && itemActive.value.id === item.id;
        }
        function activateItemById(itemId) {
            const item = slice.value.items.find(item => item.id === itemId);
            // we don't use activateItem() because we don't want to emit an event
            itemActive.value = item || null;
            if (!item) {
                activateOnLoad.value = itemId;
            }
        }
        function getActiveItemRouteParam(routeParam) {
            const param = route.params[routeParam];
            if (Array.isArray(param))
                return param[0];
            else
                return param;
        }
        function activateItemByRoute() {
            if (!props.activeItemIdRouteParam || !route || !route.params) {
                return;
            }
            const routeItemId = (typeof props.activeItemIdRouteParam === 'function')
                ? props.activeItemIdRouteParam()
                : getActiveItemRouteParam(props.activeItemIdRouteParam);
            if (routeItemId) {
                activateItemById(routeItemId);
            }
        }
        function createItemRoute(item) {
            const params = {};
            params[props.itemRouteIdParam || 'id'] = item.id;
            return {
                name: props.itemRoute, params: params,
            };
        }
        function toggleItemSelection(item) {
            itemSelections.toggle(item);
            emit('bulk-selection-changed', createBulkOperationParams());
            updateSelectedItemsCount();
        }
        function toggleAllItemSelections() {
            itemSelections.toggleAll();
            emit('bulk-selection-changed', createBulkOperationParams());
            updateSelectedItemsCount();
        }
        function updateSelectedItemsCount() {
            selectedItemsCount.value = itemSelections.count(totalElements.value);
        }
        function createBulkOperationParams() {
            return {
                searchRequest: searchRequest_.value,
                selected: () => itemSelections.selected(),
                excluded: () => itemSelections.excluded(),
            };
        }
        function getRowClass(item) {
            const rowClass = {
                'data-table__row--hover': item === itemHighlighted.value,
                'data-table__row--active': isItemActive(item),
            };
            rowClass['data-table__row--status-' + item.status] = true;
            return rowClass;
        }
        function onSearchRequestChanged(searchRequest) {
            searchRequest_.value = searchRequest;
            resetSlice();
            getTableBody().scrollTo({ top: 0 });
            saveUserSettings();
            itemSelections.clear();
            updateSelectedItemsCount();
            // TODO remove _favourites filter?
            emit('search-request-changed', searchRequest_.value);
        }
        function onBodyScroll() {
            const tableBody = getTableBody();
            refreshVisibleRows(tableBody);
            refreshVisibleColumns(tableBody);
        }
        function toggleColumn(column) {
            column.selected = !column.selected;
            saveUserSettings();
            onColumnsChanged();
        }
        function resizeColumn(column, size) {
            column.size = size;
            saveUserSettings();
            onColumnsChanged();
        }
        /**
         * 3 states:
         * unsorted => set sort asc
         * sorted asc => set sorted desc
         * sorted desc => set unsorted
         */
        function onColumnSortToggle(column) {
            if (!column.sorted) {
                column.sorted = true;
                column.sortDirection = 'asc';
            }
            else if (column.sortDirection === 'asc') {
                column.sortDirection = 'desc';
            }
            else {
                column.sorted = false;
            }
            columnsValue.value.columns
                .filter(col => col.name !== column.name)
                .forEach(col => col.sorted = false);
            resetSlice();
            saveUserSettings();
            emitColumnsChanged();
        }
        function onColumnsChanged() {
            loadItems(slice.value.range.from);
            emitColumnsChanged();
        }
        function emitColumnsChanged() {
            emit('columns-changed', columnsValue.value.columns);
        }
        function sortColumns(newColumnsOrder) {
            const reorderedColumns = [];
            columnsValue.value.columns.forEach(col => {
                const pos = newColumnsOrder.indexOf(col.name);
                reorderedColumns[pos === -1 ? reorderedColumns.length : pos] = col;
            });
            columnsValue.value.columns = reorderedColumns;
            saveUserSettings();
            emitColumnsChanged();
        }
        function applyColumnsOrderUserSettings(columnUserSettings, columns) {
            const reorderedColumns = [];
            const remainingColumns = [];
            columns.columns.forEach(col => {
                const userColumnSetting = columnUserSettings.find(c => c.name === col.name);
                const pos = userColumnSetting && userColumnSetting.position;
                if (pos === undefined) {
                    remainingColumns.push(col);
                }
                else {
                    reorderedColumns[pos] = col;
                }
            });
            remainingColumns.forEach(col => reorderedColumns.push(col));
            // Make sure we do not have an index gap (e.g. 0, 1, 3)
            const reorderedColumnsClean = [];
            reorderedColumns.forEach(col => reorderedColumnsClean.push(col));
            columns.columns = reorderedColumnsClean;
        }
        function applyColumnsSizeUserSettings(columnUserSettings, columns) {
            columns.columns.forEach(col => {
                const userColumnSetting = columnUserSettings.find(c => c.name === col.name);
                if (userColumnSetting && userColumnSetting.size) {
                    col.size = userColumnSetting.size;
                }
            });
        }
        function resetSlice() {
            slice.value = new DataItemSlice(new Range(0, 0), []);
            totalElements.value = 0;
            loadItems(0);
        }
        function refreshLimit() {
            let tableBody = getTableBody();
            if (tableBody) {
                // limit to 2 x visible rows (min 20)
                pageSize.value = Math.max(20, 2 * countVisibleItems(tableBody));
            }
        }
        let requestNum = 0;
        function loadItems(offset) {
            tooManyResults.value = false;
            loading.value = true;
            const pageNumber = Math.floor(offset / pageSize.value);
            if ((pageNumber * pageSize.value) + pageSize.value >= maxItems_.value) {
                log('getting above maxItems_: not loading any more', offset, maxItems_.value);
                tooManyResults.value = true;
                loading.value = false;
                return;
            }
            log(`loadItems - offset=${offset}, pageNumber=${pageNumber}`);
            const sortColumn = columnsValue.value.columns.find(col => col.sorted);
            const attributes = getSelectedColumnNames();
            const thisRequest = ++requestNum;
            props.source
                .get(prepareSearchRequest(searchRequest_.value), {
                number: pageNumber,
                size: pageSize.value,
                sort: sortColumn && sortColumn.name,
                order: sortColumn && sortColumn.sortDirection
            }, attributes)
                .then(page => {
                if (thisRequest != requestNum) {
                    log('throwing away results from old request #' + thisRequest);
                    return;
                }
                log('received items', page);
                emit('page-loaded', page);
                totalElements.value = page.totalElements;
                moreElements.value = page.number < (page.totalPages - 1);
                const pageOffset = page.number * page.size;
                mergeItems(new DataItemSlice(new Range(pageOffset, pageOffset + page.size), page.content));
                if (activateOnLoad.value) {
                    const itemId = activateOnLoad.value;
                    activateOnLoad.value = null;
                    activateItemById(itemId);
                }
            })
                .catch(error => {
                emit('load-error', error);
            })
                .finally(() => {
                refreshDataHeight();
                loading.value = false;
            });
        }
        function getSelectedColumnNames() {
            return columns.columns
                .filter(c => c.selected)
                .map(c => c.name);
        }
        function mergeItems(mergeSlice) {
            if (slice.value.range.intersectsOrTouches(mergeSlice.range)) {
                log(`adding to current slice ${slice.value.range.from}..${slice.value.range.to} + ${mergeSlice.range.from}..${mergeSlice.range.to}`);
                slice.value.combine(mergeSlice);
            }
            else {
                log(`replacing current slice ${slice.value.range.from}..${slice.value.range.to} + ${mergeSlice.range.from}..${mergeSlice.range.to}`);
                slice.value = mergeSlice;
            }
        }
        function determineViewMode() {
            const current = showTableColumns.value;
            showTableColumns.value = props.mode === 'list' ? false : (window.innerWidth >= 991); // $breakpoint-mobile
            if (showTableColumns.value !== current) {
                dataTableClass.value['data-table--no-columns'] = !showTableColumns.value;
                refreshDataWidth();
            }
        }
        function refreshVisibleRows(tableBody) {
            const rangeSize = countVisibleItems(tableBody);
            // determine visible range by scroll offset
            const scrollTop = tableBody.scrollTop;
            let offset = Math.floor(scrollTop / rowHeight.value);
            if (maxItems_.value) {
                offset = Math.min(maxItems_.value - rangeSize, offset);
            }
            rowActionsMarginTop.value = scrollTop * -1;
            dataTableClass.value['data-table--scroll-y'] = scrollTop > 0;
            // #activateItem automatically scrolls the table on keyboard up/down
            //   events. However, due to the "scrollIntoView" behaviour, we can't
            //   scroll lower than the last loaded item. This means that we can
            //   never retrieve additional items this way if we only fetch visible
            //   rows. => The "+1" allows fetching more.
            const visibleRange = new Range(offset, offset + rangeSize + 1);
            refreshItemsForRange(visibleRange);
        }
        function refreshItemsForRangeUnthrottled(range) {
            if (slice.value.range.contains(range)) {
                return;
            }
            log(`refreshing items for range=[${range.from}..${range.to}] (current=[${slice.value.range.from}..${slice.value.range.to}], pageSize=${pageSize.value})`);
            if (slice.value.range.intersectsOrTouches(range)) {
                // append?
                if (range.to > slice.value.range.to) {
                    log('need more items to append', range, slice.value);
                    loadItems(slice.value.range.to);
                }
                // prepend?
                if (range.from < slice.value.range.from) {
                    log('need more items to prepend', range, slice.value);
                    loadItems(slice.value.range.from - pageSize.value);
                }
                return;
            }
            log('need more items to replace current slice');
            loadItems(range.from);
        }
        function refreshVisibleColumns(tableBody) {
            if (!showTableColumns.value) {
                rowsMarginLeft.value = 0;
                listMarginLeft.value = 0;
                dataTableClass.value['data-table--scroll-x'] = false;
                return;
            }
            const scrollLeft = tableBody.scrollLeft;
            rowsMarginLeft.value = scrollLeft * -1;
            listMarginLeft.value = scrollLeft;
            dataTableClass.value['data-table--scroll-x'] = scrollLeft > 0;
        }
        function refreshDataWidth() {
            if (!showTableColumns.value) {
                dataWidth.value = 0;
                listMarginLeft.value = 0;
                return;
            }
            dataWidth.value = props.grid.columns.length === 0
                ? 0
                : props.grid.columns
                    .map(col => {
                    return colWidth(col.size);
                })
                    .reduce((w1, w2) => {
                    return w1 + w2;
                });
            headerWidth.value = dataWidth.value + listWidth.value;
        }
        function refreshDataHeight() {
            const itemsCount = maxItems_.value
                ? Math.min(maxItems_.value, totalElements.value)
                : totalElements.value;
            dataHeight.value = itemsCount * rowHeight.value;
            dataPaddingTop.value = slice.value.range.from * rowHeight.value;
        }
        function getTableBody() {
            return rootElement.value.querySelector('.data-table__body');
        }
        function countVisibleItems(tableBody) {
            return Math.ceil(tableBody.clientHeight / rowHeight.value);
        }
        function colWidth(size) {
            // NOTE: numbers as duplicated in styles
            switch (size) {
                case "s":
                    return 100;
                case "m":
                    return 200;
                case "l":
                    return 400;
                case "xl":
                    return 600;
            }
            return 200;
        }
        function saveUserSettings() {
            let position = 0;
            const columns = columnsValue.value.columns.map(col => {
                return {
                    name: col.name,
                    selected: col.selected,
                    sorted: col.sorted,
                    sortDirection: col.sortDirection,
                    position: position++,
                    size: col.size,
                };
            });
            userSettingsValue.value.set({ searchRequest: searchRequest_.value, columns: columns });
        }
        function createFilters() {
            const filters = props.grid.filters;
            if (capabilities.value.favourites) {
                filters.unshift({
                    name: '_favourites',
                    label: trans('data_table.favourites'),
                    category: 'special',
                    type: 'bool'
                });
            }
            return filters;
        }
        function prepareSearchRequest(searchRequest) {
            // replace _favourites filter with IDs filter
            const filters = [];
            (searchRequest.filters || []).forEach(filter => {
                if (filter.attribute === '_favourites') {
                    filters.push({
                        attribute: 'id',
                        operator: (filter.values[0] ? 'eq' : 'neq'),
                        values: favouriteItemsService.itemIds(props.grid.name),
                    });
                    return;
                }
                filters.push(filter);
            });
            return {
                query: searchRequest.query,
                filters: filters,
            };
        }
        function toggleFavourite(item) {
            favouriteItemsService
                .toggleItem(props.grid.name, item.id)
                .then(() => {
                if (searchRequest_.value.filters.find(f => f.attribute === '_favourites')) {
                    resetSlice();
                }
            });
        }
        function isFavourite(item) {
            return favouriteItemsService.isSelected(props.grid.name, item.id);
        }
        function loadStatistics() {
            if (!props.statistics) {
                return Promise.reject();
            }
            return props.statistics.get(searchRequest_.value, [] /* TODO */);
        }
        function hasStatusBadgeColumn() {
            return props.grid.columns.some(col => col.name === 'status' && col.dataType === 'badge');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "rootElement",
                ref: rootElement,
                class: _normalizeClass(["data-table", dataTableClass.value])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "title", {}, () => [
                            (__props.title)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.title), 1),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (__props.description)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "data-table__description",
                                            title: __props.description
                                        }, _toDisplayString(__props.description), 9, _hoisted_5))
                                        : _createCommentVNode("", true),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    (__props.helpCode)
                                        ? (_openBlock(), _createBlock(Help, {
                                            key: 1,
                                            code: __props.helpCode
                                        }, null, 8, ["code"]))
                                        : _createCommentVNode("", true),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    (__props.showBadges)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.grid.badges, (badge, index) => {
                                                return (_openBlock(), _createBlock(BadgeComponent, {
                                                    class: "data-table__badge",
                                                    key: index
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(badge), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[10] || (_cache[10] = _createTextVNode()),
                        (capabilities.value.search && searchRequest_.value)
                            ? (_openBlock(), _createBlock(SearchFilters, {
                                key: 0,
                                name: __props.name,
                                filters: filters.value,
                                "no-search-query": __props.grid.capabilities && __props.grid.capabilities.searchQueries === false,
                                "search-request": searchRequest_.value,
                                "search-query-placeholder": __props.searchQueryPlaceholder || _ctx.$t('search.placeholder'),
                                onKeydown: [
                                    _withKeys(_withModifiers(activateNextItem, ["exact", "stop"]), ["down"]),
                                    _withKeys(_withModifiers(activatePrevItem, ["exact", "stop"]), ["up"])
                                ],
                                onUpdate: onSearchRequestChanged
                            }, null, 8, ["name", "filters", "no-search-query", "search-request", "search-query-placeholder", "onKeydown"]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_7, [
                        (searchRequest_.value)
                            ? _renderSlot(_ctx.$slots, "actions", {
                                key: 0,
                                searchRequest: searchRequest_.value,
                                item: itemActive.value
                            })
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[26] || (_cache[26] = _createTextVNode()),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                            class: "data-table__columns",
                            style: _normalizeStyle({ width: (headerWidth.value ? headerWidth.value + 'px' : 'auto'), marginLeft: rowsMarginLeft.value + 'px' })
                        }, [
                            _createElementVNode("div", _hoisted_10, [
                                (capabilities.value.bulkOperations)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("input", {
                                            checked: _unref(itemSelections).isAllSelected(),
                                            onClick: _cache[0] || (_cache[0] = ($event) => (toggleAllItemSelections())),
                                            type: "checkbox",
                                            name: "select-all"
                                        }, null, 8, _hoisted_12)
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_13, [
                                    (loading.value && totalElements.value === 0)
                                        ? (_openBlock(), _createBlock(Spinner, {
                                            key: 0,
                                            loading: true
                                        }))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (selectedItemsCount.value > 0 && selectedItemsCount.value < totalElements.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(_toDisplayString(selectedItemsCount.value) + " /\n                                ", 1)
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(_unref(numberFilter)(totalElements.value)) + " ", 1),
                                            (selectedItemsCount.value > 0 && __props.bulkOperations && __props.bulkOperations.length > 0)
                                                ? (_openBlock(), _createBlock(DataTableBulkOperations, {
                                                    key: 1,
                                                    operations: __props.bulkOperations,
                                                    params: createBulkOperationParams,
                                                    "button-variant": __props.variant === 'condensed' ? 'small' : undefined
                                                }, null, 8, ["operations", "button-variant"]))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _createTextVNode(_toDisplayString(_ctx.$te(__props.name + '._items') ? _ctx.$t(__props.name + '._items') : (_ctx.$te(__props.name + '.items') ? _ctx.$t(__props.name + '.items') : _ctx.$t('items'))), 1)
                                                ], 64)),
                                            _cache[12] || (_cache[12] = _createTextVNode()),
                                            _renderSlot(_ctx.$slots, "list-header-cell")
                                        ], 64))
                                ])
                            ]),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            (showTableColumns.value)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(columnsValue.value.columns, (column) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (column.selected)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: column.name,
                                                class: _normalizeClass(["data-table__column", [
                                                        'data-table__column--size-' + column.size,
                                                        'data-table__column--type-' + column.dataType,
                                                        // column.name may contain periods, but a CSS identifier can't!
                                                        'data-table__column--column-' + column.name.replaceAll('\.', '_')
                                                    ]]),
                                                title: column.label
                                            }, [
                                                _renderSlot(_ctx.$slots, 'column-' + column.name.replaceAll('\.', '_'), { column: column }, () => [
                                                    _createElementVNode("span", _hoisted_15, _toDisplayString(column.label), 1)
                                                ]),
                                                _cache[14] || (_cache[14] = _createTextVNode()),
                                                _createVNode(ColumnSort, {
                                                    column: column,
                                                    onToggle: onColumnSortToggle
                                                }, null, 8, ["column"])
                                            ], 10, _hoisted_14))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 256))
                                : _createCommentVNode("", true),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            (capabilities.value.statistics)
                                ? (_openBlock(), _createBlock(DataTableStatistics, {
                                    key: 1,
                                    class: "data-table__statistics",
                                    grid: __props.grid,
                                    loader: loadStatistics,
                                    "reload-trigger": searchRequest_.value
                                }, null, 8, ["grid", "reload-trigger"]))
                                : _createCommentVNode("", true),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            (showTableColumns.value)
                                ? (_openBlock(), _createBlock(DataTableColumnsSelection, {
                                    key: 2,
                                    columns: columnsValue.value.columns,
                                    onToggle: toggleColumn,
                                    onSort: sortColumns,
                                    onResize: resizeColumn
                                }, null, 8, ["columns"]))
                                : _createCommentVNode("", true)
                        ], 4)
                    ]),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    _createElementVNode("div", {
                        class: "data-table__body",
                        onScrollPassive: onBodyScroll
                    }, [
                        _createElementVNode("div", {
                            class: "data-table__data",
                            style: _normalizeStyle({ width: (dataWidth.value ? dataWidth.value + 'px' : 'auto'), height: dataHeight.value + 'px', paddingTop: dataPaddingTop.value + 'px' }),
                            onMouseout: _cache[6] || (_cache[6] = ($event) => (itemHighlighted.value = null))
                        }, [
                            _createElementVNode("div", {
                                class: "data-table__list",
                                onKeydown: [
                                    _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event) => (activateNextItem()), ["exact", "prevent"]), ["tab"])),
                                    _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event) => (activateNextItem()), ["exact", "prevent"]), ["j"])),
                                    _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event) => (activatePrevItem()), ["exact", "shift", "prevent"]), ["tab"])),
                                    _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event) => (activatePrevItem()), ["exact", "prevent"]), ["k"]))
                                ],
                                style: _normalizeStyle({ marginLeft: listMarginLeft.value + 'px' })
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slice.value.items, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.id,
                                        ref_for: true,
                                        ref: (el) => { itemRefs.value[item.id] = el; },
                                        class: _normalizeClass(["data-table__row", getRowClass(item)]),
                                        onMouseover: ($event) => (itemHighlighted.value = item)
                                    }, [
                                        item
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                (capabilities.value.bulkOperations)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                        _createElementVNode("input", {
                                                            checked: _unref(itemSelections).isSelected(item),
                                                            onClick: ($event) => (toggleItemSelection(item)),
                                                            type: "checkbox",
                                                            name: "select"
                                                        }, null, 8, _hoisted_19)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _cache[20] || (_cache[20] = _createTextVNode()),
                                                _createElementVNode("div", {
                                                    onClick: ($event) => (activateItem(item)),
                                                    class: "data-table__list-item"
                                                }, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _renderSlot(_ctx.$slots, "list-item", { item: item }, () => [
                                                            (__props.itemRoute)
                                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                                    key: 0,
                                                                    to: createItemRoute(item)
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(item.topic), 513), [
                                                                            [_vShow, item.topic]
                                                                        ]),
                                                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                                                        _createElementVNode("span", _hoisted_22, _toDisplayString(item.title), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["to"]))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(item.topic), 513), [
                                                                        [_vShow, item.topic]
                                                                    ]),
                                                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                                                    _createElementVNode("span", _hoisted_23, _toDisplayString(item.title), 1)
                                                                ], 64))
                                                        ])
                                                    ])
                                                ], 8, _hoisted_20)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 42, _hoisted_16));
                                }), 128)),
                                _cache[21] || (_cache[21] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_24, [
                                    (tooManyResults.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t(_ctx.$te(__props.name + '.too_many_results') ? (__props.name + '.too_many_results') : 'search.too_many_results', { max_items: (_unref(numberFilter)(maxItems_.value)) })), 1))
                                        : (_openBlock(), _createBlock(Spinner, {
                                            key: 1,
                                            loading: true
                                        }))
                                ], 512), [
                                    [_vShow, moreElements.value]
                                ])
                            ], 36),
                            _cache[24] || (_cache[24] = _createTextVNode()),
                            (showTableColumns.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "data-table__rows",
                                    style: _normalizeStyle({ marginLeft: rowsMarginLeft.value + 'px' })
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slice.value.items, (item) => {
                                        return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.itemRoute ? 'RouterLink' : 'div'), {
                                            key: item.id,
                                            to: __props.itemRoute ? createItemRoute(item) : null,
                                            class: _normalizeClass(["data-table__row", getRowClass(item)]),
                                            onMouseover: ($event) => (itemHighlighted.value = item),
                                            onClick: ($event) => (__props.itemRoute || activateItem(item))
                                        }, {
                                            default: _withCtx(() => [
                                                item
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnsValue.value.columns, (column) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                                (column.selected)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: column.name,
                                                                        class: _normalizeClass(["data-table__cell", [
                                                                                'data-table__cell--size-' + column.size,
                                                                                'data-table__cell--type-' + column.dataType,
                                                                                // column.name may contain periods, but a CSS identifier can't!
                                                                                'data-table__cell--column-' + column.name.replaceAll('\.', '_'),
                                                                            ]])
                                                                    }, [
                                                                        _renderSlot(_ctx.$slots, 'cell-' + column.name.replaceAll('\.', '_'), { item: item }, () => [
                                                                            _createElementVNode("div", _hoisted_26, [
                                                                                _createVNode(DataTableCell, {
                                                                                    value: item.attributes[column.name],
                                                                                    type: column.dataType,
                                                                                    "show-nulls": __props.showNulls,
                                                                                    item: item,
                                                                                    column: column,
                                                                                    "translation-prefix": (__props.translationPrefix || '') + column.name + '.'
                                                                                }, null, 8, ["value", "type", "show-nulls", "item", "column", "translation-prefix"])
                                                                            ])
                                                                        ])
                                                                    ], 2))
                                                                    : _createCommentVNode("", true)
                                                            ], 64));
                                                        }), 256)),
                                                        _cache[23] || (_cache[23] = _createTextVNode()),
                                                        _createElementVNode("div", {
                                                            onClick: _cache[5] || (_cache[5] = _withModifiers(() => { }, ["stop"])),
                                                            class: "data-table__row-actions",
                                                            style: _normalizeStyle({ marginTop: rowActionsMarginTop.value + 'px' })
                                                        }, [
                                                            _renderSlot(_ctx.$slots, "item-actions", { item: item }),
                                                            _cache[22] || (_cache[22] = _createTextVNode()),
                                                            (capabilities.value.favourites)
                                                                ? (_openBlock(), _createElementBlock("a", {
                                                                    key: 0,
                                                                    onClick: _withModifiers(($event) => (toggleFavourite(item)), ["prevent"]),
                                                                    class: "button button--icon button--link",
                                                                    href: "",
                                                                    title: _ctx.$t('data_table.toggle_favourite')
                                                                }, [
                                                                    _createVNode(Icon, {
                                                                        name: "star",
                                                                        "icon-style": isFavourite(item) ? 'solid' : 'regular'
                                                                    }, null, 8, ["icon-style"])
                                                                ], 8, _hoisted_27))
                                                                : _createCommentVNode("", true)
                                                        ], 4)
                                                    ], 64))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                        }, 1064, ["to", "class", "onMouseover", "onClick"]));
                                    }), 128))
                                ], 4))
                                : _createCommentVNode("", true)
                        ], 36)
                    ], 32)
                ])
            ], 2));
        };
    }
});
